import { AppProvider } from './context';
import React, { Component } from 'react';
import Search from './components/search.component';
import FullLayout from './components/full-layout.component';
import Map from './components/map.component';
import Text from './components/text.component';
import { LanguageType } from './types/language.type';

class App extends Component<{type: string, language?: string}> {
  state: any;
  constructor (props: any) {
    super(props);
    this.state = {
      tablet: this.isTablet(),
      mobile: this.isMobile()
    };
  }

  updateDimensions = () => {
    this.setState({
      tablet: this.isTablet(),
      mobile: this.isMobile()
    });
  };

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
    window.addEventListener('popstate', (e) => {
      window.location.reload();
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
    window.removeEventListener('popstate', (e) => {
      window.location.reload();
    });
  }

  isTablet () {
    return (window.innerWidth < 1415);
  }

  isMobile () {
    return (window.innerWidth < 970);
  }

  render () {
    return (
      <AppProvider>
        <Text language={this.props.language as LanguageType || 'fr'}/>
        {(this.props.type === 'full' || !['search', 'map'].includes(this.props.type)) &&
          <FullLayout isTablet={this.state.tablet} isMobile={this.state.mobile} />
        }
        {this.props.type === 'search' &&
          <>
            <Search redirect={true} isTablet={this.state.tablet} isMobile={this.state.mobile} />
            <Map noUrl={true} height={'700px'} isTablet={this.state.tablet} isMobile={this.state.mobile} />
          </>
        }
        {this.props.type === 'map' &&
          <Map noUrl={true} doSearch={true} height={'700px'} isTablet={this.state.tablet} isMobile={this.state.mobile} />
        }
      </AppProvider>
    );
  }
}
export default App;
